import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, FloatingLabel, Form, Tab, Tabs } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import AsyncSelect from 'react-select/async';
import { useSelector } from "react-redux";
import { getData, postData } from "../../api/ApiRest";
import ReactQuill from "react-quill";
import { FaEye, FaPlus, FaSave } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Paper } from "@mui/material";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";
import { FaList } from "react-icons/fa6";

function SoporteCRUD() {
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState({});

    const [usuariosAsignados, setUsuariosAsignados] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [comentarios, setComentarios] = useState([]);

    const [infoComentario, setInfoComentario] = useState({
        comentario: '', user: ''
    });

    const [infoContactos, setInfoContactos] = useState({
        nombre: '', telefono: '', correo: ''
    });

    const [infoAdjuntos, setInfoAdjuntos] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [contactos, setContactos] = useState([]);

    const navigate = useNavigate();
    const companyId = useSelector((state) => state.auth.CompanyId);
    const id = useParams().id;

    const infoUser = useSelector((state) => state.auth);

    useEffect(() => {
        setInfoComentario({
            user: infoUser.user
        });

        usuariosCompany();

        if (companyId !== null && companyId !== 'null') ///Si cuenta con companyID quiere decir que es el cliente que inicio sesión
            infoCliente();

        if (id != 0) {
            getInfoPQR();
            getAdjuntos();
        } else {
            const fechaActual = new Date().toLocaleString("es-CO");

            setInfo({
                ...info,
                Fecha: fechaActual,
                Estado: 'C',
                Tipo: 'Ac'
            });
        }
    }, [companyId]);

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    ///Acción para traer los usuarios posibles a asignar
    const usuariosCompany = () => {
        setLoading(true);

        getData('api/Configuracion/Soporte/usuariosCompany', {}).then(response => {

            setUsuariosAsignados(response.usuarios);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    ///Acción para traer la información principal del cliente
    const infoCliente = () => {
        setLoading(true);

        getData('api/Configuracion/Soporte/infoCliente', {
            companyId: companyId
        }).then(response => {
            setInfo({
                ...info,
                Identificacion: response.nit,
                RazonSocial: response.nombre
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const toolbarOptions = useMemo(
        () => [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }, { size: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
        []
    );

    ///Ref que se utiliza para el texto enriquecido
    const quillRef = useRef(null);

    //Formatos permitidos en el texto enriquecido
    const formats = [
        "header",        // Encabezados
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image", "video", // Multimedia
        "color", "background",    // Colores
        "align", "font", "size"   // Alineación, fuentes y tamaños
    ];

    ///Modulos o propiedades que aparecen en el titulo enriquecido
    const modules = useMemo(
        () => ({
            toolbar: {
                container: toolbarOptions
            },
        }),
        [toolbarOptions]
    );

    ///Acción para guardar la información de un PQR
    const guardarPQR = () => {
        setLoading(true);

        let objecto = {
            tipo: info.Tipo,
            titulo: info.Titulo,
            descripcion: info.Descripcion,
            estado: info.Estado,
            nombre: '',
            correo: '',
            telefono: '',
            cliente: info.Cliente,
            identificacion: info.Identificacion || '',
            asignado: info.Asignado,
            prioridad: info.Prioridad,
            nombre_cliente: info.RazonSocial || '',
            tipo_solicitud: info.TipoSolicitud || ''
        };

        postData('api/Configuracion/Soporte/guardarInfoPqr', {
            id: id
        }, objecto).then(response => {
            if (response.status) {
                alert(response.msj);
                navigate('/Home/PqrCRUD/' + response.id);

                window.location.reload();
            } else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Acción para traer toda la información del ticket que se guardo
    const getInfoPQR = () => {
        getData('api/Configuracion/Soporte/getInfoPQR', {
            id: id
        }).then(response => {

            setInfo({
                ...info,
                Ticket: id,
                Fecha: response.infoSoporte.fecha,
                Tipo: response.infoSoporte.tipo,
                Cliente: response.infoSoporte.cliente,
                Titulo: response.infoSoporte.titulo,
                Prioridad: response.infoSoporte.prioridad,
                Estado: response.infoSoporte.estado,
                Asignado: response.infoSoporte.asignado,
                Descripcion: response.infoSoporte.descripcion,
                Nombre: response.infoSoporte.nombre,
                Telefono: response.infoSoporte.telefono,
                Correo: response.infoSoporte.correo,
                UsuarioAsignado: response.usuarioAsignado,
                SoportePadreId: response.infoSoporte.soportepadreid,
                TipoSolicitud: response.infoSoporte.tipo_solicitud,
                Numero: response.infoSoporte.numero
            });

            setContactos(response.soporteContacto);

            setTickets(response.soporteTickets);

            setSelectedOptions({
                value: response.infoSoporte.cliente,
                label: response.infoSoporte.identificacion + " - " + response.infoSoporte.nombre_cliente
            });
        }, error => {
            console.log(error);
        });
    }

    ///Función para convertir el estado en letra al texto correspondiente
    const estadoText = (estado) => {
        if (estado === "C")
            return 'Creación';
        else if (estado === "P")
            return 'Proceso';
        else if (estado === 'S')
            return 'Solucionado';
        else if (estado === "R")
            return 'Rechazado';
    }

    const documentosUpload = (File) => {
        if (File != null) {
            setLoading(true);

            const formData = new FormData();
            formData.append("file", File);

            let UrlBase = infoUser.AmbienteTae_Url +
                'api/Configuracion/Soporte/DocumentoUpload?soporteid=' + id;

            const token = infoUser.tokenSesion;

            fetch(UrlBase, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json'
                },
                body: formData
            }).then(response => response.json())
                .then(data => {
                    if (data.status) {
                        alert('Adjunto cargado con éxito');
                        setInfoAdjuntos(data.list);
                    } else {
                        alert('Ha ocurrido un error');
                    }

                    setLoading(false);
                })
                .catch(error => {
                    alert('Algo salio mal en la petición');
                    console.log(error);
                    setLoading(false);
                })
        }
    }

    const getAdjuntos = () => {
        setLoading(true);

        getData('api/Configuracion/Soporte/visualizarAdjunto', {
            pqrid: id
        }).then(response => {
            setInfoAdjuntos(response.list);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const visualizarAdjunto = (archivo) => {
        window.open('https://api-pro1.tae-col.com/PQR/' + archivo, '_blank');
    }

    ///Acción para poder agregar un comentario dependiendo del usuario
    const agregarComentario = () => {
        setLoading(true);

        postData('api/Configuracion/Soporte/agregarComentario', {
            soporteid: id
        }, infoComentario).then(response => {
            if (response.status) {
                setComentarios(prev => [
                    ...prev,
                    {
                        soportecomentarioid: response.list[0].soportecomentarioid,
                        user: response.list[0].user,
                        comentario: response.list[0].comentario,
                        escliente: response.list[0].escliente,
                        fecha: response.list[0].fecha
                    }
                ]);

                setInfoComentario({
                    comentario: '',
                    user: ''
                });
            } else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const getComentarios = () => {
        setLoading(true);

        getData('api/Configuracion/Soporte/getComentariosTicket', {
            soporteid: id
        }).then(response => {
            if (response.status) {
                setComentarios(response.list);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const agregarContacto = () => {
        setLoading(true);

        postData('api/Configuracion/Soporte/agregarContacto', {
            soporteid: id,
            nombre: infoContactos.nombre,
            correo: infoContactos.correo,
            telefono: infoContactos.telefono
        }, {}).then(response => {
            if (response.status) {
                alert(response.msj);

                setContactos(prev => [
                    ...prev,
                    {
                        nombre: response.list.nombre,
                        correo: response.list.correo,
                        telefono: response.list.telefono,
                    }
                ]);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const generarTickets = () => {
        setLoading(true);

        let cantidad = prompt('¿Cuantos tickets vas a crear?');

        if (cantidad === null) {
            return;
        }

        if (cantidad == 0) {
            alert('Debes de ingresar un número distinto de cero');
            return;
        }

        getData('api/Configuracion/Soporte/crearTicketsMasivos', {
            soporteid: id,
            cantidad: cantidad
        }).then(response => {
            if (response.status) {
                alert(response.msj);
                window.location.reload();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const visualizarTicket = (soporteid) => {
        window.open('/Home/PqrCRUD/' + soporteid, '_blank');
    }

    return <div className='BodyComponent'>

        {<LoadingComponent Loading={loading} />}

        <Tabs
            defaultActiveKey={"general"}
            id="uncontrolled-tab-example"
            onSelect={key => {
                if (key === 'comentario') {
                    getComentarios();
                }
            }}
            className="mb-3 custom-tabs"
        >
            <Tab eventKey="general" title="GENERAL">
                <Card>
                    <Card.Header className='bg-dark text-white text-center'>PQR
                    </Card.Header>
                    <Card.Body>

                        <div className="row">
                            <div className="col-md-2">
                                <FloatingLabel
                                    controlId="Registro"
                                    label="Registro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="number"
                                        autoComplete='off'
                                        placeholder="Ticket"
                                        value={info.Numero}
                                        readOnly
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-3">
                                <FloatingLabel
                                    controlId="Fecha"
                                    label="Fecha"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="datetime"
                                        autoComplete='off'
                                        placeholder="Fecha"
                                        value={info.Fecha}
                                        readOnly
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-2">
                                <FloatingLabel
                                    controlId='Tipo'
                                    label="Tipo"
                                    className="mb-2"
                                >
                                    <Form.Select
                                        value={info.Tipo}
                                        onChange={event => {
                                            setInfo({ ...info, Tipo: event.target.value })
                                        }}
                                    >
                                        <option value="">Seleccione</option>
                                        {companyId === 'null' || companyId === null ? <option value="Ac">Acta</option> : ""}
                                        <option value="T">Ticket</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </div>
                            {info.Tipo === 'Ac' ? null : <div className="col-md-2">
                                <FloatingLabel
                                    controlId='Tipo solicitud'
                                    label="Tipo solicitud"
                                    className="mb-2"
                                >
                                    <Form.Select
                                        value={info.TipoSolicitud}
                                        onChange={event => {
                                            setInfo({ ...info, TipoSolicitud: event.target.value })
                                        }}
                                    >
                                        <option value="">Seleccione</option>
                                        <option value="Q">Queja</option>
                                        <option value="E">Error</option>
                                        <option value="S">Solicitud</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </div>}

                            {companyId === 'null' || companyId === null ? <div className={info.Tipo === 'Ac' ? 'col-md-5' : 'col-md-3'}>
                                <AsyncSelect cacheOptions defaultOptions
                                    menuPosition='fixed'
                                    noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                                    placeholder="Cliente"
                                    isClearable={true}
                                    loadOptions={companieSearchSelect2}
                                    onChange={value => {
                                        if (value === null) {
                                            setInfo({ ...info, Cliente: '' });
                                            setSelectedOptions({ ...selectedOptions, value: null, label: null });
                                        } else {
                                            setInfo({ ...info, Cliente: value.value });
                                            setSelectedOptions({ ...selectedOptions, value: value.value, label: value.label });
                                        }
                                    }}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: 58
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    isDisabled={
                                        id !== '0' ? true : false
                                    }
                                    value={selectedOptions}
                                />
                            </div> : null}

                            {companyId !== 'null' && companyId !== null ?
                                <>
                                    <div className='col-md-5'>
                                        <FloatingLabel
                                            controlId="Identificación"
                                            label="Identificación"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                size='sm'
                                                type="text"
                                                autoComplete='off'
                                                placeholder="Identificación"
                                                value={info.Identificacion}
                                                readOnly
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className='col-md-12'>
                                        <FloatingLabel
                                            controlId="Cliente"
                                            label="Cliente"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                size='sm'
                                                type="text"
                                                autoComplete='off'
                                                placeholder="Razon social"
                                                value={info.RazonSocial}
                                                readOnly
                                            />
                                        </FloatingLabel>
                                    </div>
                                </>

                                : null}

                        </div>
                        <div className="row">
                            <div className={companyId === 'null' || companyId === null ? "col-md-4" : "col-md-9"}>
                                <FloatingLabel
                                    controlId="Titulo"
                                    label="Titulo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="text"
                                        autoComplete='off'
                                        placeholder="Titulo"
                                        value={info.Titulo}
                                        onChange={event => {
                                            setInfo({ ...info, Titulo: event.target.value })
                                        }}
                                        readOnly={id != 0 && info.SoportePadreId === null ? true : false}
                                    />
                                </FloatingLabel>
                            </div>
                            {companyId === 'null' || companyId === null ?
                                <div className="col-md-2">
                                    <FloatingLabel
                                        controlId='Prioridad'
                                        label="Prioridad"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={info.Prioridad}
                                            onChange={event => {
                                                setInfo({ ...info, Prioridad: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            <option value="A">Alta</option>
                                            <option value="B">Baja</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                </div> : null}
                            <div className="col-md-3">
                                {info.UsuarioAsignado === infoUser.user ?
                                    <FloatingLabel
                                        controlId='Estado'
                                        label="Estado"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={info.Estado}
                                            onChange={event => {
                                                setInfo({ ...info, Estado: event.target.value })
                                            }}
                                        >
                                            <option value="C">Creación</option>
                                            <option value="P">Proceso</option>
                                            <option value="S">Solucionado</option>
                                            <option value="R">Rechazado</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                    : <FloatingLabel
                                        controlId="Estado"
                                        label="Estado"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            size='sm'
                                            type="text"
                                            autoComplete='off'
                                            placeholder="Estado"
                                            value={estadoText(info.Estado)}
                                            readOnly
                                        />
                                    </FloatingLabel>}

                            </div>
                            {companyId === 'null' || companyId === null ?
                                <div className="col-md-3">
                                    <FloatingLabel
                                        controlId='Asignado'
                                        label="Asignado a"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={info.Asignado}
                                            onChange={event => {
                                                setInfo({ ...info, Asignado: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {usuariosAsignados.map((item, key) =>
                                                <option key={key} value={item.value}>{item.text}</option>)}
                                        </Form.Select>
                                    </FloatingLabel>
                                </div> : null}
                        </div>
                        <div className="row">
                            <ReactQuill
                                ref={quillRef}
                                theme="snow"
                                value={info.Descripcion}
                                onChange={(content) => setInfo({ ...info, Descripcion: content })}
                                modules={modules}
                                style={{
                                    height: "250px",
                                    maxHeight: "300px",
                                    overflowY: "auto"
                                }}
                                formats={formats}
                                readOnly={id != 0 && info.SoportePadreId === null ? true : false} />
                        </div>
                        <br />
                        <div className="row">
                            {companyId === 'null' || companyId === null ?

                                <div className="col-md-2" style={{ justifyContent: 'space-between', display: 'flex', alignItems: "center", textAlign: 'right' }}>
                                    <Button variant='success' type='submit' onClick={() => guardarPQR()}>
                                        <FaSave size={'1rem'} />
                                    </Button>
                                </div>

                                : null}
                            {info.Tipo === 'Ac' ?
                                <div className="col-md-2" style={{ justifyContent: 'space-between', display: 'flex', alignItems: "center", textAlign: 'right' }}>
                                    <Button variant='warning' type='submit' onClick={() => generarTickets()}>
                                        <FaList size={'1rem'} />
                                    </Button>
                                </div>
                                : null}
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
            <Tab eventKey="adjuntos" title="ADJUNTOS">
                <Card>
                    <Card.Header className='bg-dark text-white text-center'>ADJUNTOS
                    </Card.Header>
                    <Card.Body>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-label">Cargue de archivos</label>
                                <input className="form-control" type="file"
                                    onChange={file => {
                                        documentosUpload(file.target.files[0]);
                                    }} />
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className='table-responsive mt-2'>
                                <table className='table table-borderless table-hover'>
                                    <thead>
                                        <tr>
                                            <th className="estilo-encabezado"></th>
                                            <th className="estilo-encabezado">#</th>
                                            <th className="estilo-encabezado">Archivo</th>
                                            <th className="estilo-encabezado">Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {infoAdjuntos.map((item, index) => (
                                            <tr key={index} style={{ fontSize: 14 }}>
                                                <td className="text-center">
                                                    <Button type="button" variant="primary" onClick={() => visualizarAdjunto(item.archivo)}
                                                        style={{
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                            fontSize: 12
                                                        }}>
                                                        <FaEye />
                                                    </Button>
                                                </td>
                                                <td className="text-center">
                                                    {index + 1}
                                                </td>
                                                <td className="text-center">
                                                    {item.archivo}
                                                </td>
                                                <td className="text-center">
                                                    {formatDateddMMMyyyy(item.fecha)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>

            <Tab eventKey="contacto" title="CONTACTO">
                <Card>
                    <Card.Header className='bg-dark text-white text-center'>CONTACTO
                    </Card.Header>
                    <Card.Body>
                        <div className="row">
                            <div className="col-md-3">
                                <FloatingLabel
                                    controlId="Nombre"
                                    label="Nombre"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="text"
                                        autoComplete='off'
                                        placeholder="Nombre"
                                        value={infoContactos.nombre}
                                        onChange={event => {
                                            setInfoContactos({ ...infoContactos, nombre: event.target.value })
                                        }}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-4">
                                <FloatingLabel
                                    controlId="Correo"
                                    label="Correo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="text"
                                        autoComplete='off'
                                        placeholder="Correo"
                                        value={infoContactos.correo}
                                        onChange={event => {
                                            setInfoContactos({ ...infoContactos, correo: event.target.value })
                                        }}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-3">
                                <FloatingLabel
                                    controlId="Telefono"
                                    label="Telefono"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        type="number"
                                        autoComplete='off'
                                        placeholder="Telefono"
                                        value={infoContactos.telefono}
                                        onChange={event => {
                                            setInfoContactos({ ...infoContactos, telefono: event.target.value })
                                        }}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-sm btn-success" title="Agregar contacto" onClick={() => agregarContacto()} type="button">
                                    <FaPlus />
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className='table-responsive mt-2'>
                                <table className='table table-borderless table-hover'>
                                    <thead>
                                        <tr>
                                            <th className="estilo-encabezado">#</th>
                                            <th className="estilo-encabezado">Nombre</th>
                                            <th className="estilo-encabezado">Correo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contactos.map((item, index) => (
                                            <tr key={index} style={{ fontSize: 14 }}>
                                                <td className="text-center">
                                                    {index + 1}
                                                </td>
                                                <td className="text-center">
                                                    {item.nombre}
                                                </td>
                                                <td className="text-center">
                                                    {item.correo}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
            <Tab eventKey="comentario" title="COMENTARIOS">
                <Card>
                    <Card.Header className='bg-dark text-white text-center'>COMENTARIOS
                    </Card.Header>
                    <Card.Body>
                        <div className="row">
                            <div className="col-md-10">
                                <FloatingLabel
                                    controlId="Comentario"
                                    label="Comentario"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        as='textarea'
                                        rows={4}
                                        autoComplete='off'
                                        style={{ height: "120px" }}
                                        placeholder="Comentario"
                                        value={infoComentario.comentario}
                                        onChange={event => {
                                            setInfoComentario({ ...infoComentario, comentario: event.target.value })
                                        }}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-md-2">
                                <Button variant='success' type='submit' onClick={() => agregarComentario()}>
                                    <FaPlus size={'1rem'} />
                                </Button>
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                    <Paper sx={{ p: 1, borderRadius: 3 }}>
                                        {comentarios.length > 0 && comentarios.map((msj) => (
                                            <div
                                                key={msj.soportecomentarioid}
                                                className={`mensaje-row ${msj.escliente ? "left" : "right"}`}
                                            >
                                                <div className="mensaje-burbuja">
                                                    <div className="mensaje-label">{msj.user}</div>
                                                    <div className="mensaje-label">{msj.fecha ? msj.fecha.replace('T', ' ') : null}</div>

                                                    <div className="mensaje-texto">
                                                        {msj.comentario}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Paper>
                                </Grid>
                            </Grid>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>

            {info.Tipo === "Ac" ? <Tab eventKey="tickets" title={"TICKETS (" + tickets.length + ")"}>
                <Card>
                    <Card.Header className='bg-dark text-white text-center'>Tickets
                    </Card.Header>
                    <Card.Body>
                        <div className="row">
                            <div className='table-responsive mt-2'>
                                <table className='table table-borderless table-hover'>
                                    <thead>
                                        <tr>
                                            <th className="estilo-encabezado"></th>
                                            <th className="estilo-encabezado">#</th>
                                            <th className="estilo-encabezado">Titulo</th>
                                            <th className="estilo-encabezado">Estado</th>
                                            <th className="estilo-encabezado">Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tickets.map((item, index) => (
                                            <tr key={index} style={{ fontSize: 14 }}>
                                                <td className="text-center">
                                                    <button type="button" title="Visualizar tickets" className="btn btn-sm btn-primary" onClick={() => visualizarTicket(item.soporteid)}>
                                                        <FaEye />
                                                    </button>
                                                </td>
                                                <td className="text-center">
                                                    {index + 1}
                                                </td>
                                                <td className="text-center">
                                                    {item.titulo}
                                                </td>
                                                <td className="text-center">
                                                    {estadoText(item.estado)}
                                                </td>
                                                <td className="text-center">
                                                    {formatDateddMMMyyyy(item.fecha)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab> : null}
        </Tabs>
    </div>
}

export default SoporteCRUD;